import React,  { useEffect } from 'react';

const FilterComp = (props) => {

  useEffect(() => {
    if (props.filters.comp == 'All') {
      document.querySelector('#comp-all').checked = true;
    }
    
  }, [props.filters]);

  return (
    <div className='filter-radio-input'>
      <div>
        <input type="radio" id="comp-all" name="comp" value="All" onClick={props.handleCompFilter} />
        <label htmlFor="comp-all">All</label>
      </div>

      {Object.entries(props.compSet).map(([typeId, type], i) => (
        <div key={i}>
          <input type="radio" id={type} name="comp" value={type} onClick={props.handleCompFilter} />
          <label htmlFor={type}>{type}</label>
        </div>
      ))}
    </div>
  );
};

export default FilterComp;